document.addEventListener('DOMContentLoaded', () => {

  // ── Transparent header: add .is-scrolled when page scrolls ──
  const header = document.getElementById('site-header');
  const annBar = document.querySelector('.ann-bar');

  if (header) {
    const annH = annBar ? annBar.offsetHeight : 0;

    const onScroll = () => {
      if (window.scrollY > annH + 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run on load in case page is already scrolled
  }

  // ── Mobile nav ──
  const burger = document.getElementById('burger-btn');
  const mobileNav = document.getElementById('mobile-nav');
  const closeBtn = document.getElementById('mobile-close');

  const openNav = () => {
    mobileNav.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeNav = () => {
    mobileNav.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  if (burger) burger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  // Close on outside tap
  document.addEventListener('click', (e) => {
    if (mobileNav && mobileNav.classList.contains('open') &&
        !mobileNav.contains(e.target) && burger && !burger.contains(e.target)) {
      closeNav();
    }
  });

});
